module.exports = require('./lib/dist/DonutChart.js');